import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium drv-mb-1" }
const _hoisted_3 = { class: "form-wrapper row drv-gap-4 drv-py-2" }

import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IBaseBasic,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'SurfsightAccountName',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const isDiasbled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref<boolean>(false);

const emit = __emit;

const EMPTY_MODEL = { type: EAuthTypes.BASIC, username: "", password: "" };

const model = computed<IBaseBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseBasic) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.BASIC
  );
});

const url = computed<string | null>(() => {
  return currentMethod.value?.url ?? null;
});

const isConnectionValid = ref<boolean | null>(
  props.modelValue || !currentMethod.value?.check_connection ? true : null
);

const nameControl = ref<typeof Input | null>(null);
const passwordControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !usernameModel.value ||
    nameControl.value?.hasError ||
    !passwordModel.value ||
    passwordControl.value?.hasError
  );
});

const hasError = computed<boolean>(() => {
  return !isConnectionValid.value || hasFormError.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).SURFSIGHT_BASIC_TITLE)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_d_input, {
        ref_key: "nameControl",
        ref: nameControl,
        modelValue: usernameModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
        disable: isDiasbled.value,
        class: "drv-form-control-adaptive",
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).SURFSIGHT_BASIC_USERNAME_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "disable", "label", "rules"]),
      _createVNode(_component_d_password_input, {
        ref_key: "passwordControl",
        ref: passwordControl,
        class: "drv-form-control-adaptive",
        disable: isDiasbled.value,
        modelValue: passwordModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordModel).value = $event)),
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).SURFSIGHT_BASIC_PASSWORD_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["disable", "modelValue", "label", "rules"])
    ])
  ]))
}
}

})